import React from 'react'
const WebContext = React.createContext(null)
export { WebContext }